import { global_faqs } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type FAQsProps } from './FAQs';

export const faqsSchema = global_faqs.transform<FAQsProps>(data => ({
  items: data.faq.map<FAQsProps['items'][number]>(faq => {
    return {
      question: faq.question,
      answer: faq.answer,
      link: {
        href: faq.link_href.href,
        text: faq.link_href.title,
      },
    };
  }),
}));
